angular.module('rjmNg.controllers').controller('setPasswordCtrl', [
  "$scope"
  "$modal"
  "$http"
  "app"
  "$url"
  "Users"
  ($scope, $modal, $http, app, $url, Users) ->
    $scope.userId = app.getUserId()

    $scope.password = ""
    $scope.confirmPassword = ""
    $scope.updating = false

    $scope.termsOfServiceUrl = () ->
      return 'https://magento.com/legal/terms'

    passwordIsValid = (password) ->
      password?.length >= 8 and password.match(/\d/)? and password.match(/[^A-Za-z0-9 _-]/)?

    updateError = () ->
      $scope.formError = {}

      if $scope.password.length is 0
        $scope.formError.password = "You must enter a password."
      else if not passwordIsValid($scope.password)
        $scope.formError.password = "Passwords must contain at least eight characters, one number, and at least one special character such as ! $ % @ # ^ * or &."

      if $scope.confirmPassword.length is 0
        $scope.formError.confirmPassword = "You must confirm the password."
      else if $scope.confirmPassword isnt $scope.password
        $scope.formError.confirmPassword = "Passwords do not match."

      numErrors = Object.keys($scope.formError).length

      if numErrors > 1
        $scope.formError.form = "Fix the indicated errors before continuing."
      else if numErrors is 1
        $scope.formError.form = "Fix the indicated error before continuing."

    $scope.setPassword = (modal) ->
      updateError()
      return if $scope.formError.form?

      $scope.updating = true

      # Make sure we set this so we can access other dashboards
      app.resetUserRandomPassword()

      Users.updatePassword($scope.userId, null, $scope.password)
      .then () ->
        modal('hide')
      .catch () ->
        $scope.formError.form = "Something went wrong. Please try again later."
      .finally () ->
        $scope.updating = false

  ]
)
